import { render, staticRenderFns } from "./FormCreateClient.vue?vue&type=template&id=de4d845a&"
import script from "./FormCreateClient.vue?vue&type=script&lang=js&"
export * from "./FormCreateClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports